import axios from 'axios';
import { Dispatch } from 'redux';
import {
  NpcFbaFreightAction,
  NpcFbaFreightActionTypes
} from '../../types/npcFbaFreight';
import { npcTypes } from '../../utils/constants';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

const CancelToken = axios.CancelToken;
let cancelFbaFreight: any = null;
let cancelFbaFreightAnalytics: any = null;
let cancelFbaFreightAnalyticsChart: any = null;

export const getNpcFbaFreight =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_LOADING
      });

      if (cancelFbaFreight) {
        cancelFbaFreight();
        cancelFbaFreight = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelFbaFreight = c;
        })
      };

      const res = await axios.post('/api/npcreports/fbaFreight', body, config2);
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_LOADING
      });
    }
  };

export const getNpcFbaFreightTotal =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TOTAL_LOADING
      });

      const res = await axios.get(
        `/api/npcreports/fbaFreight/total?from=${data.from}&to=${data.to}`
      );
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TOTAL,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TOTAL,
        payload: {}
      });
    }
  };

export const getNpcFbaFreightParams =
  () => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    const body = JSON.stringify({ types: [npcTypes.fbaFreight.value] });
    try {
      const res = await axios.post('/api/npc/params', body, config);
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_PARAMS,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_PARAMS,
        payload: {}
      });
    }
  };

export const getNpcFbaFreightMinDate =
  () => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    const body = JSON.stringify({ types: [npcTypes.fbaFreight.value] });
    try {
      const res = await axios.post('/api/npc/mindate', body, config);
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_MINDATE,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_MINDATE,
        payload: ''
      });
    }
  };

export const getNpcFbaFreightBrand =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_BRAND_LOADING
      });

      const res = await axios.get(
        `/api/npcreports/fbaFreight/brand?from=${data.from}&to=${data.to}&brandId=${data.brandId}&locations=${data.locations}`
      );
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_BRAND,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_BRAND,
        payload: {}
      });
    }
  };

export const getNpcFbaFreightTransaction =
  (data: { name: string; locations: string }) =>
  async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    try {
      const { name, locations } = data;

      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TRANSACTION_LOADING
      });

      const res = await axios.get(
        `/api/npcreports/fbaFreight/transaction?name=${name}&locations=${locations}`
      );
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TRANSACTION,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TRANSACTION,
        payload: {}
      });
    }
  };

interface IupdateFbaFreightTransaction {
  id: string | number;
  message: string;
}

export const updateFbaFreightTransaction =
  (data: IupdateFbaFreightTransaction) =>
  async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    try {
      const { id, message } = data;
      const body = JSON.stringify({ message });
      await axios.put(`/api/npcreports/fbaFreight/expense/${id}`, body, config);
      dispatch({
        type: NpcFbaFreightActionTypes.UPDATE_NPC_FBA_FREIGHT_TRANSACTION,
        payload: { id, message }
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcFbaFreightActionTypes.UPDATE_NPC_FBA_FREIGHT_TRANSACTION,
        payload: null
      });
    }
  };

export const getFbaFreightAnalytics =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING
      });

      if (cancelFbaFreightAnalytics) {
        cancelFbaFreightAnalytics();
        cancelFbaFreightAnalytics = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelFbaFreightAnalytics = c;
        })
      };

      const res = await axios.post(
        '/api/npcreports/fbaFreightAnalytics',
        body,
        config2
      );
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS,
        payload: { analytics: {}, analytics_charts: {} }
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING
      });
    }
  };

export const getFbaFreightAnalyticsChart =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING
      });

      if (cancelFbaFreightAnalyticsChart) {
        cancelFbaFreightAnalyticsChart();
        cancelFbaFreightAnalyticsChart = null;
      }

      const config2 = {
        cancelToken: new CancelToken(function executor(c) {
          cancelFbaFreightAnalyticsChart = c;
        })
      };

      const res = await axios.get(
        `/api/npcreports/fbaFreightAnalytics?from=${data.from}&to=${data.to}`,
        config2
      );

      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS_CHART,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS_CHART,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING
      });
    }
  };

export const getFbaFreightInboundFee =
  (data: any) => async (dispatch: Dispatch<NpcFbaFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING
      });
      const res = await axios.post(
        '/api/npcreports/fbaFreightInboundFee',
        body,
        config
      );
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_INBOUND_FEE,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_INBOUND_FEE,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING
      });
    }
  };

export const clearNpcFbaFreight =
  () => async (dispatch: Dispatch<NpcFbaFreightAction>) => {
    dispatch({
      type: NpcFbaFreightActionTypes.CLEAR_NPC_FBA_FREIGHT
    });
  };
